import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Slider from "react-slick";
import { AiFillDollarCircle } from "react-icons/ai";
import { BsFillMortarboardFill } from "react-icons/bs";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";

const Program = () => {

  const listProgram = [
    { name:"Business & Management", desc:"Skill bisnis fundamental yang bisa kamu pakai buat kerja corporate, startup, atau jadi entrepreneur.", img:"assets/images/program1.webp", degree:"Bachelor (S1)", tuition:"€12,000 - €14,000/tahun" },
    { name:"IT & Computing", desc:"Dunia digital berkembang pesat - skill coding, data & IT itu high demand banget.", img:"assets/images/program2.webp", degree:"Undergraduate / Postgraduate", tuition:"€12,000 - €14,000/tahun" },
    { name:"Media, Creative & Film", desc:"Cocok buat kamu yang tertarik content creation, film, media, atau design.", img:"assets/images/program3.webp", degree:"Undergraduate / Postgraduate", tuition:" €12,000 - €14,000/tahun (tergantung jurusan)" },
    { name:"Law & Social Sciences", desc:"Dasar hukum & sosial itu bagus buat karier di banyak bidang, termasuk public sector & NGO.", img:"assets/images/program4.webp", degree:"Undergraduate / Postgraduate", tuition:"€12,000 - €14,000/tahun" },
  ]

  const NextArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow next" onClick={onClick}>
        <FaChevronRight size={24} />
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow prev" onClick={onClick}>
        <FaChevronLeft size={24} />
      </div>
    );
  };

  const settings = {
    className: "center",
    dots: true,
    infinite: true,
    speed: 500,
    
    centerMode: false,
    centerPadding: "0px",
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,     
    responsive: [   
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },        
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: "35px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },            
    ],    
  };

  return (
    <>
      <section className="section" id="program">
        <Container>
          <Row className="">
            <Col className="">
              <div className="slide-wrapper">
                <h1 className="mb-3"><b>Program Studi Unggulan</b></h1>
                  <Slider {...settings}>
                    {listProgram.map((item, id) =>(
                      <Card key={id} className=''>
                        <img
                          alt={item.name}
                          src={item.img}
                          className="img-fluid"
                        />
                        <CardBody>
                          <div className="row">
                            <div className="col-1">
                            <BsFillMortarboardFill color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.name}</p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-1">
                            <AiFillDollarCircle color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.tuition}</p>
                            </div>
                          </div>     
                          <div className="mt-3">{item.desc}</div>                 
                        </CardBody>
                      </Card>
                    ))}
                  </Slider>
                <p className="note">*Catatan: Biaya berbeda per jurusan & lokasi kampus, dan bisa ada biaya tambahan administrasi.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Program;